export default "__VITE_ASSET__YafJ2FUe__"